<template>
    <sa-page-layout :btnNewVisible="false" :btnRefreshVisible="true" :btnBackVisible="false" @refresh="onRefresh" :pathResource="pathResource" :linkedit="linkedit" :linkback="linkback" :showModalLoading="showModalLoading">
        <template slot="table-filter">
            <b-form @submit.prevent="onSubmit">
                <b-row style="margin-left: 0.5rem; margin-right: 0.5rem">
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Numero Ordine:</label>
                        <b-form-input v-model="filtro.codice" type="search" id="nominativo" placeholder="Numero Ordine"></b-form-input>
                    </b-col>
                    <b-col v-if="clientiEnable" cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Cliente:</label>
                        <b-form-select v-model="filtro.idCliente" :options="tipoAnagraficaOptions" :value="''" value-field="id" text-field="nominativo"></b-form-select>
                    </b-col>
                    <b-col v-else cols="12" xs="12" sm="12" md="6" lg="6" xl="6"> </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Data Dal</label>
                        <date-picker v-model="filtro.dataDal" format="DD-MM-YYYY" value-type="timestamp" type="timestamp"></date-picker>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Data Al</label>
                        <date-picker v-model="filtro.dataAl" format="DD-MM-YYYY" value-type="timestamp" type="timestamp"></date-picker>
                    </b-col>
                </b-row>
                <b-row style="margin-left: 0.5rem; margin-right: 0.5rem; margin-bottom: -2rem">
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="sa-padding-right pt-3 pb-3 text-right">
                        <b-button type="submit" variant="info">{{ this.$i18n.t("patients.lblFind") }}</b-button>
                        <b-button type="reset" v-on:click="onReset" variant="danger">{{ this.$i18n.t("patients.lblResetFilter") }}</b-button>
                    </b-col>
                </b-row>
            </b-form>
        </template>
        <template slot="table-body">
            <ordini-list-component ref="OrdiniListComponent" @beforLoadData="onBeforeLoadData" @afterLoadData="onAfterLoadData"></ordini-list-component>
        </template>
    </sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import UtilityMixin from "../../utility/UtilityMixin";
import OrdiniListComponent from "../components/OrdiniListComponent.vue";
import DatePicker from "vue2-datepicker";
import Vue from "vue";
export default {
    mixins: [UtilityMixin],
    components: { SaPageLayout, OrdiniListComponent, DatePicker },
    data() {
        return {
            filtro: { codice: "", idCliente: "", dataDal: null, dataAl: null },
            btnNewVisible: true,
            btnBackVisible: true,
            linkback: "/papercleandocumentotipi",
            pathResource: "/articoli",
            pathResourceTipiAnagrafica: "/users",
            codiceTipo: "",
            clientiEnable: false,
            linkedit: "/rsagestioneospiti",
            tipoAnagraficaOptions: [{ id: "", nominativo: "-Seleziona Valore-" }],
            showModalLoading: false,
            listKey: 0,
        };
    },
    mounted() {
        let me = this;
        me.codiceTipo = this.$route.query.codiceTipo;
        me.clientiEnable = UtilityMixin.methods.verificaPermessi(Vue.prototype.user, "ordini", 1);
        me.loadTipiAnagrafica();
    },
    methods: {
        loadTipiAnagrafica() {
            let me = this;
            let filtro = {};
            filtro.profilo = "CLIENTE";
            me.tipoAnagraficaOptions = [];
            me.clientiEnable = UtilityMixin.methods.verificaPermessi(Vue.prototype.user, "ordini", 1);
            UtilityMixin.methods.loadDataResources(me.pathResourceTipiAnagrafica, filtro, me.loadTipiAnagraficaSuccess, me.loadTipiAnagraficaError);
        },
        loadTipiAnagraficaSuccess(response) {
            let me = this;
            response.data.data.list.forEach((element) => {
                me.tipoAnagraficaOptions.push({ id: element.id, nominativo: element.lastname + " " + element.firstname });
            });
            me.tipoAnagraficaOptions.unshift({ id: "", nominativo: "-Seleziona Valore-" });
            me.loadData();
        },
        loadTipiAnagraficaError(response) {
            console.log(response);
        },
        loadData() {
            let me = this;
            me.showModalLoading = true;
            me.clientiEnable = UtilityMixin.methods.verificaPermessi(Vue.prototype.user, "ordini", 1);
            me.$refs.OrdiniListComponent.loadData(me.filtro, me.tipoAnagraficaOptions);
        },

        onRefresh() {
            let me = this;
            me.loadData();
        },
        onAfterLoadData() {
            let me = this;
            me.showModalLoading = false;
        },
        onBeforeLoadData() {
            let me = this;
            me.showModalLoading = true;
        },
        onReset() {
            let me = this;
            me.filtro = { nome: null, cognome: null, identificativo: null, dataDal: null, dataAl: null };
            let sessionStorage = window.sessionStorage;
            sessionStorage["filtro"] = JSON.stringify(me.filtro);
            me.loadData();
        },
        onSubmit() {
            let me = this;
            let sessionStorage = window.sessionStorage;
            sessionStorage["filtro"] = JSON.stringify(me.filtro);
            me.loadData();
        },
    },
};
</script>

<style></style>
